import { render, staticRenderFns } from "./quickview.vue?vue&type=template&id=1b60c792&scoped=true&xmlns%3Av-swiper=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./quickview.vue?vue&type=script&lang=js&"
export * from "./quickview.vue?vue&type=script&lang=js&"
import style0 from "./quickview.vue?vue&type=style&index=0&id=1b60c792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b60c792",
  null
  
)

export default component.exports